export class Press<A> {
  #key: string | null = null;
  action: A | null = null;

  down(key: string, repeat: boolean, action: A): boolean {
    if (repeat || this.#key !== null) return false;
    this.#key = key;
    this.action = action;
    return true;
  }

  up(key: string): A | null {
    if (this.#key === null || key !== this.#key) return null;
    const action = this.action;
    this.cancel();
    return action;
  }

  cancel(): void {
    this.#key = null;
    this.action = null;
  }
}

export function watchAlt(set: (held: boolean) => void): () => void {
  const down = (e: KeyboardEvent) => set(e.key === "Alt" || e.altKey);
  const up = (e: KeyboardEvent) => {
    if (e.key === "Alt") {
      e.preventDefault();
      set(false);
    } else {
      set(e.altKey);
    }
  };
  const blur = () => set(false);
  addEventListener("keydown", down);
  addEventListener("keyup", up);
  addEventListener("blur", blur);
  return () => {
    removeEventListener("keydown", down);
    removeEventListener("keyup", up);
    removeEventListener("blur", blur);
  };
}
